module.exports = __webpack_public_path__ + "img/Warlock-human-m-70.46d03972.gif";